/* IV Supply Clinic: add to cart from custom sections, then open the theme's cart drawer. */
if (!window.__ivscAddToCart) {
window.__ivscAddToCart = true;
document.addEventListener('submit', async function (event) {
var form = event.target.closest('form.ivsc-ajax-add');
if (!form) return;
var drawer = document.querySelector('cart-drawer');
if (!drawer || typeof drawer.renderContents !== 'function' || !window.routes) return;
event.preventDefault();
var button = form.querySelector('[type="submit"]');
if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
var data = new FormData(form);
data.append('sections', 'cart-drawer,cart-icon-bubble');
data.append('sections_url', window.location.pathname);
try {
var res = await fetch(window.routes.cart_add_url, {
method: 'POST',
headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
body: data
});
var json = await res.json();
if (json.status) { form.submit(); return; }
if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
drawer.renderContents(json);
} catch (e) {
form.submit();
} finally {
if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
}
});
}
